module.exports = __webpack_public_path__ + "img/default-img.30b3fb56.png";